import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@app/redux/reducers/state';
import { identifyPendoVisitor } from '@app/utils/pendo';

/**
 * Identifies the Pendo visitor once Okta sign-in and tenant selection have both landed in Redux.
 * Those two facts arrive separately, so waiting on both here is what keeps a visitor from being
 * identified against an empty organisation. Renders nothing.
 */
const PendoIdentify = () => {
  const visitorId = useSelector((state: RootState) => state.auth.user?.sub);
  const accountId = useSelector((state: RootState) => state.auth.tenant);

  useEffect(() => {
    if (visitorId && accountId) identifyPendoVisitor(visitorId, accountId);
  }, [visitorId, accountId]);

  return null;
};

export default PendoIdentify;
